module.exports = __webpack_public_path__ + "img/mechas.2ffcd976.png";